import clonePlanAction from '../clone'
import updateCurrentPlanAction from '../set-current'
import canEditByIdPlanSelector from '../../selectors/can-edit-by-id'
import getCurrentPlanSelect from '../../selectors/get-current'
import { getIdReduxUtil } from '../../../redux/utils/get-id'

function cloneIfCantEditPlanAction (plan) {
  return async (dispatch, getState) => {
    plan = plan || getCurrentPlanSelect(getState())
    if (canEditByIdPlanSelector(getIdReduxUtil(plan))(getState())) {
      return plan
    }

    plan = await dispatch(clonePlanAction({
      plan
    }))

    dispatch(updateCurrentPlanAction(plan))

    return plan
  }
}

export default cloneIfCantEditPlanAction
